import { BlinkLiveData } from '~/types';

export function aggregateBlinkLiveData(state: BlinkLiveData, events: BlinkLiveData): BlinkLiveData {
    const newState = { ...state };

    // Iterate over the keys of the events object
    Object.keys(events).forEach((key) => {
        // If the key doesn't exist in the state object, create it with default values
        if (!(key in newState)) {
            newState[key] = { Viewed: 0, Clicked: 0, Loaded: 0 };
        }

        const event = events[key];

        // Update the values in the state object based on the incoming events
        if (event.Viewed) {
            newState[key].Viewed = (newState[key].Viewed || 0) + event.Viewed;
        }
        if (event.Clicked) {
            newState[key].Clicked = (newState[key].Clicked || 0) + event.Clicked;
        }
        if (event.Loaded) {
            newState[key].Loaded = (newState[key].Loaded || 0) + event.Loaded;
        }
    });
    return newState;
}

export function summarizeEvents(data: BlinkLiveData, eventType: 'Clicked' | 'Viewed'): number {
    const clicks = Object.entries(data).map(([_, v]) => {
        const clicks = Object.entries(v).map(([type, count]) => {
            if (type == eventType) {
                return Number(count);
            } else return 0;
        });
        return clicks.reduce((a, c) => a + c, 0);
    });
    return clicks.reduce((a, c) => a + c, 0);
}
